import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Strategy = () => {
  const sectionRef = useRef(null);
  const lineRef = useRef(null);

  useEffect(() => {
    if (lineRef.current) {
      gsap.to(lineRef.current, {
        width: '100%',
        duration: 1.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: lineRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    }
  }, []);

  return (
    <section className="section_strategy" ref={sectionRef}>
      <div className="padding-global">
        <div className="container-large">
          <div data-horizontal-line-anim="true" className="horizontal-line" ref={lineRef} style={{ width: '0%' }}></div>
          <div className="spacer-1-5 spacer-mobile-1"></div>
          <h2>Our SOL Treasury Strategy</h2>
          <div className="spacer-7-5 spacer-mobile-3"></div>
          <div className="w-layout-grid grid is-treasury">
            {/* Strategy Component 1 */}
            <div className="treasury-strategy_component">
              <div className="treasury-number_wrapper">
                <div className="typeface-dm-mono">
                  <div className="text-color-white">
                    <div>1</div>
                  </div>
                </div>
              </div>
              <div className="treasury-icon-text_wrapper">
                <div data-svg-height-100="true" className="treasury-icon w-embed">
                  <svg viewBox="0 0 60 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="30" cy="24" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="30" cy="10" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="30" cy="52" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="30" cy="66" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="16" cy="38" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="2" cy="38" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="16" cy="24" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="16" cy="52" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="44" cy="38" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="58" cy="38" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="44" cy="24" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="44" cy="52" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="23" cy="31" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="23" cy="17" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="9" cy="31" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="23" cy="45" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="23" cy="59" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="9" cy="45" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="37" cy="31" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="37" cy="17" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="51" cy="31" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="37" cy="45" r="2" fill="#8AFFE4" fillOpacity="0.5"></circle>
                    <circle cx="37" cy="59" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="51" cy="45" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                  </svg>
                </div>
                <div className="treasury-text_wrapper">
                  <div className="heading-style-h4">
                    <div className="text-weight-semibold">
                      <div className="text-color-white">
                        <div>Acquire SOL</div>
                      </div>
                    </div>
                  </div>
                  <div className="text-color-white">
                    <div>Build up SOL reserve by opportunistically leveraging capital markets through the raise of equity and debt.</div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Strategy Component 2 */}
            <div className="treasury-strategy_component">
              <div className="treasury-number_wrapper">
                <div className="typeface-dm-mono">
                  <div className="text-color-white">
                    <div>2</div>
                  </div>
                </div>
              </div>
              <div className="treasury-icon-text_wrapper">
                <div data-svg-height-100="true" className="treasury-icon w-embed">
                  <svg viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="38" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="38" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="38" cy="10" r="2" fill="#8AFFE4"></circle>
                    <circle cx="38" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="38" cy="66" r="2" fill="#8AFFE4"></circle>
                    <circle cx="24" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="10" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="24" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="24" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="52" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="66" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="52" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="52" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="31" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="31" cy="17" r="2" fill="#8AFFE4"></circle>
                    <circle cx="17" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="31" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="31" cy="59" r="2" fill="#8AFFE4"></circle>
                    <circle cx="17" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="45" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="45" cy="17" r="2" fill="#8AFFE4"></circle>
                    <circle cx="59" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="45" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="45" cy="59" r="2" fill="#8AFFE4"></circle>
                    <circle cx="59" cy="45" r="2" fill="#8AFFE4"></circle>
                    <rect x="0.5" y="0.5" width="75" height="75" stroke="#8AFFE4"></rect>
                  </svg>
                </div>
                <div className="treasury-text_wrapper">
                  <div className="heading-style-h4">
                    <div className="text-weight-semibold">
                      <div className="text-color-white">
                        <div>Maximize Yield</div>
                      </div>
                    </div>
                  </div>
                  <div className="text-color-white">
                    <div>Stake SOL to earn yield on SOL holdings</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Strategy Component 3 */}
            <div className="treasury-strategy_component">
              <div className="treasury-number_wrapper">
                <div className="typeface-dm-mono">
                  <div className="text-color-white">
                    <div>3</div>
                  </div>
                </div>
              </div>
              <div className="treasury-icon-text_wrapper">
                <div data-svg-height-100="true" className="treasury-icon w-embed">
                  <svg viewBox="0 0 148 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="74" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="74" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="74" cy="10" r="2" fill="#8AFFE4"></circle>
                    <circle cx="74" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="74" cy="66" r="2" fill="#8AFFE4"></circle>
                    <circle cx="60" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="46" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="60" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="60" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="88" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="102" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="88" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="88" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="67" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="67" cy="17" r="2" fill="#8AFFE4"></circle>
                    <circle cx="53" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="67" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="67" cy="59" r="2" fill="#8AFFE4"></circle>
                    <circle cx="53" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="81" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="81" cy="17" r="2" fill="#8AFFE4"></circle>
                    <circle cx="95" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="81" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="81" cy="59" r="2" fill="#8AFFE4"></circle>
                    <circle cx="95" cy="45" r="2" fill="#8AFFE4"></circle>
                    <rect x="36.5" y="0.5" width="75" height="75" stroke="#8AFFE4"></rect>
                    <rect x="0.5" y="14.5" width="36" height="47" stroke="#8AFFE4"></rect>
                    <rect x="111.5" y="14.5" width="36" height="47" stroke="#8AFFE4"></rect>
                  </svg>
                </div>
                <div className="treasury-text_wrapper">
                  <div className="heading-style-h4">
                    <div className="text-weight-semibold">
                      <div className="text-color-white">
                        <div>Leverage DeFi</div>
                      </div>
                    </div>
                  </div>
                  <div className="text-color-white">
                    <div>Explore DeFi to earn yield using low-risk strategies to maximise returns on SOL holdings.</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Strategy Component 4 */}
            <div className="treasury-strategy_component">
              <div className="treasury-number_wrapper">
                <div className="typeface-dm-mono">
                  <div className="text-color-white">
                    <div>4</div>
                  </div>
                </div>
              </div>
              <div className="treasury-icon-text_wrapper">
                <div data-svg-height-100="true" className="treasury-icon w-embed">
                  <svg viewBox="0 0 60 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="30" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="30" cy="10" r="2" fill="#8AFFE4"></circle>
                    <circle cx="30" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="30" cy="66" r="2" fill="#8AFFE4"></circle>
                    <circle cx="16" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="2" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="16" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="2" cy="24" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="2" cy="52" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="2" cy="66" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="44" cy="66" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="16" cy="66" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="58" cy="66" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="9" cy="59" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="51" cy="59" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="58" cy="52" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="16" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="44" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="58" cy="38" r="2" fill="#8AFFE4"></circle>
                    <circle cx="44" cy="24" r="2" fill="#8AFFE4"></circle>
                    <circle cx="58" cy="24" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="44" cy="52" r="2" fill="#8AFFE4"></circle>
                    <circle cx="23" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="23" cy="17" r="2" fill="#8AFFE4"></circle>
                    <circle cx="9" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="9" cy="17" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="16" cy="10" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="2" cy="10" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="44" cy="10" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="58" cy="10" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="51" cy="17" r="2" fill="#8AFFE4" fillOpacity="0.3"></circle>
                    <circle cx="23" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="23" cy="59" r="2" fill="#8AFFE4"></circle>
                    <circle cx="9" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="37" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="37" cy="17" r="2" fill="#8AFFE4"></circle>
                    <circle cx="51" cy="31" r="2" fill="#8AFFE4"></circle>
                    <circle cx="37" cy="45" r="2" fill="#8AFFE4"></circle>
                    <circle cx="37" cy="59" r="2" fill="#8AFFE4"></circle>
                    <circle cx="51" cy="45" r="2" fill="#8AFFE4"></circle>
                  </svg>
                </div>
                <div className="treasury-text_wrapper">
                  <div className="heading-style-h4">
                    <div className="text-weight-semibold">
                      <div className="text-color-white">
                        <div>Monetize Premium</div>
                      </div>
                    </div>
                  </div>
                  <div className="text-color-white">
                    <div>Monetize premium to net asset value of SOL holdings by issuing equity to acquire more SOL.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Strategy;